import { Link } from "react-router-dom";
import { BRAND_ASSETS } from "@/utils/brandAssets";

const PATHS = [
  { code: "01", label: "Nutrition", copy: "Food and metabolic support with source-backed category signals.", image: BRAND_ASSETS.metabolicSignals, to: "/?category=nutrition" },
  { code: "02", label: "Movement", copy: "Training, studios, and movement specialists matched to your goals.", image: BRAND_ASSETS.movementVitality, to: "/?category=fitness" },
  { code: "03", label: "Recovery", copy: "Recovery, sleep, stress, and restoration services near you.", image: BRAND_ASSETS.recoveryReadiness, to: "/?category=recovery" },
  { code: "04", label: "Providers", copy: "Evidence-aware professionals across the wider wellness continuum.", image: BRAND_ASSETS.clinicalScan, to: "/?category=services" },
];

export function ConnectedDiscoverySection() {
  return (
    <section className="bg-[#081334] py-12 text-white md:py-16" data-testid="connected-discovery-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <p className="font-mono text-xs uppercase text-white/55"><span className="text-[#F45B63]">§</span> Connected discovery</p>
          <h2 className="mt-3 font-heading text-3xl font-bold leading-tight sm:text-4xl">One wellness system. <span className="text-[#F45B63]">Four ways in.</span></h2>
          <p className="mt-4 font-body text-base leading-relaxed text-white/70">Move from a wellness goal to real places and providers, with evidence and review status visible at every step.</p>
        </div>
        <div className="mt-8 grid grid-cols-2 gap-px border border-white/15 bg-white/15 lg:grid-cols-4">
          {PATHS.map((path) => (
            <Link key={path.code} to={path.to} className="group min-w-0 bg-[#081334] transition-colors duration-200 hover:bg-white/[0.07]" data-testid={`discovery-path-${path.label.toLowerCase()}`}>
              <div className="relative aspect-[4/3] overflow-hidden lg:aspect-[16/10]">
                <img src={path.image} alt={`${path.label} wellness discovery`} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]" loading="lazy" data-testid={`discovery-path-image-${path.code}`} />
                <div className="absolute inset-0 bg-navy-dark/35" aria-hidden="true" />
                <span className="absolute left-3 top-3 border border-white/40 bg-navy-dark/80 px-2 py-1 font-mono text-xs text-white">{path.code}</span>
              </div>
              <div className="border-t border-white/15 p-4">
                <h3 className="font-heading text-xl font-bold text-white transition-colors duration-200 group-hover:text-[#F45B63]">{path.label}</h3>
                <p className="mt-1.5 font-body text-sm leading-relaxed text-white/65">{path.copy}</p>
                <span className="mt-3 inline-flex font-mono text-xs uppercase text-[#F45B63]">Explore →</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}